export enum PATHS {
  SIGN_UP = '/auth/sign-up',
  LOGIN = '/auth/login',
  WEBSITE = '/',
  SEND_VERIFY_LINK = '/auth/verify-link-send',
  FORGOT_PASSWORD = '/auth/forgot-password',
  RESET_PASSWORD = '/auth/reset-password',
  CONFIRM_VERIFY = '/auth/sign-up-verified',
  ONBOARDING = '/auth/onboarding',
  MAIN = '/main',
  NOT_FOUND = '/*',
  DASHBOARD = '/dashboard',
  DASHBOARD_WRAPPER = '/dashboard/:id',
  REPORTED_ISSUE_ID = '/dashboard/:id/:issueId',
  HOME = '/home',
  MY_REPORTS = '/my-reports',
  MY_REPORTS_ISSUE_ID = '/my-reports/:id/:issueId',
  ACCOUNT = '/account/:pageTab',
  SUPPORT = '/support',
  FAQ = '/faq',
  PLAN = '/plan',
  ACCESSIBILITY_DASHBOARD = 'accessibility-dashboard',
  // SITEMAP = 'sitemap',
  AUTOMATED_AUDIT = 'issues/automated-audit',
  AUTOMATED_AUDIT_SELECT = 'dashboard/automated-audit/select',
  AUTOMATED_AUDIT_RUNS = 'issues/automated-audit/all',
  AUTOMATED_AUDIT_SPECIFIC_RUN = 'issues/automated-audit/all/:runId/:tracking_number',
  MANUAL_AUDIT = 'manual-audit',
  WIDGET = 'widget',
  REPORTED = 'reported',
  USERS = '/users',
  REPORTS = '/reports',
  BASENAME = '/insight',
  SETTINGS = 'settings',
  MANAGE_ORGANIZATION_ACCESS = ':organizationId',
  COMPANIES = ':organizationId/companies',
  SCAN = '/scan',
  // COMPANY='/manage-company/:pageTab/',
  // COMPANIESWEBSITE = ':organizationId/companies/websites/:company_id',
  // ORGANIZATIONWEBSITE = ':organizationId/granted-websites',
  // USERSOFCOMPANY = '/manage-company/:companyId/users',
  // USERWEBSITES = '/manage-company/:companyId/user/:userId/websites',
  ACCOUNTDETAILS = '/account/account-details/:option/:siteUUID',
  PASSWORD = "/account/password",
  NOTIFICATION = '/account/notifications',
  ORGANIZATION = '/account/organisations',
  CLIENT = '/account/clients',
  MANAGEUSERS = '/account/manage-user',
  MANAGEWEBSITES = '/account/manage-wesiste',
  MANAGETAGS = '/account/manage-tags',
  // PERMISSIOM = '/account/permissiom',
  COMPANY='/manage-company/Notifications',
  // COMPANIESWEBSITE = ':organizationId/companies/websites/:company_id',
  // ORGANIZATIONWEBSITE = ':organizationId/granted-websites'
  // PERMISSIOM = '/account/permissiom'
  BILLINGPAGE='/account/billings',
  TOOLS = '/account/tools',
  SINGLEPAGECHECKER= '/account/singlepagechecker',
  CODEACCESSIBILITY= '/account/accessibility-code-checker',
  LANGUAGELEVELCHECKER= "/account/languagelevelchecker",
  IMAGECOLORCONSTRACTCHECkER= "/account/imagecolercontentchecker",
  IMAGEDESCRIPTIONCHECKER="/account/imagedescriptionchecker",
  ACCOUNT_PAGE = '/account/account-details'
}
